import React from 'react'
import SingleCounter from './SingleCounter'
import "./Counters.css"


function Counters() {
  return (

    <section className="counter">
<SingleCounter/>
<SingleCounter/>
<SingleCounter/>
<SingleCounter/>
<SingleCounter/>

  </section>  )
}

export default Counters